import React from 'react';
import { ThumbsContainer, ThumbsElement } from './ThumbsStyles';

function Thumbs({ photos, idCurrentPhoto, setIdCurrentPhoto }) {
  const onMouseEnterHandler = (id) => () => setIdCurrentPhoto(id);

  if (photos.length < 2) {
    return null;
  }

  return (
    <ThumbsContainer>
      {photos.map((src, i) => (
        <ThumbsElement
          key={src}
          idx={i}
          src={src}
          idCurrentPhoto={idCurrentPhoto}
          onMouseEnter={onMouseEnterHandler(i)}
        />
      ))}
    </ThumbsContainer>
  );
}

export default Thumbs;
